/**
 * Helpers de listas de precios.
 *
 * Reglas del sistema (Feb 2026):
 *  - POS/Mostrador  → siempre usa la lista configurada como "lista POS"
 *                     (setting global). El operador puede cambiarla para la
 *                     venta ACTUAL desde un dropdown; al terminar la venta
 *                     vuelve automáticamente a la del setting.
 *  - Pedidos TN /
 *    WhatsApp / Manual → siempre facturan con la lista flagueada
 *                     `es_lista_tn = true`. Aunque el cliente tenga otra
 *                     lista asignada, TN pisa.
 *  - Facturación en Ventas/Ctas.Ctes clientes (sin origen POS ni pedido)
 *                     → usa la lista del cliente (`cliente.lista_precios_id`).
 *
 * La antigua "lista default por usuario" (`user.lista_precios_default_id`)
 * fue removida — ya no pisa a nadie.
 */

/**
 * Devuelve el ID de lista de precios a usar para una venta de facturación
 * normal (no POS, no pedido TN). Sólo usa la lista del cliente. Si el
 * cliente no tiene, cae a null.
 */
export function getEffectiveListaId(cliente /*, user (ignorado, legacy) */) {
  return cliente?.lista_precios_id || null;
}

/**
 * Busca la lista flagueada como `es_lista_tn` en el catálogo. Se usa para
 * facturar pedidos TN / WhatsApp / manuales.
 */
export function getListaTN(listasPrecios) {
  return (listasPrecios || []).find((l) => l && l.es_lista_tn === true) || null;
}

/**
 * Devuelve la lista que debe usar el POS por defecto. Prioridad:
 *   1. `settingPosListaId` (setting global editable por admin).
 *   2. Lista flagueada `es_lista_pos` (legacy fallback si alguien la usa).
 *   3. Primera lista del catálogo.
 */
export function getListaPosDefault(listasPrecios, settingPosListaId) {
  const arr = listasPrecios || [];
  if (settingPosListaId) {
    const found = arr.find((l) => l.id === settingPosListaId);
    if (found) return found;
  }
  const flagged = arr.find((l) => l && l.es_lista_pos === true);
  if (flagged) return flagged;
  return arr[0] || null;
}
